import React, { Component } from 'react'
import { uniqueId } from 'lodash'
import InputMessage from '../InputMessage'
import InputValid from '../InputValid'

import cn from 'classnames'
import s from './Input.scss'

export default class Input extends Component {
  static defaultProps = {
    display: 'standard',
  }
  constructor(props) {
    super(props)
    this.state = {
      inputId: uniqueId('input'),
    }
  }
  onChange = event => {
    const { model, storeChange } = this.props
    storeChange(model, event.target.value)
  }
  render() {
    const {
      input,
      labelUp,
      label,
      disabled,
      children,
      type,
      color,
      hideDot,
      className,
      display,
      classNameOuter,
      info,
      meta: { error, warning, active },
      ...otherProps
    } = this.props
    const { inputId } = this.state

    const outerClasses = cn(
      display === 'box' ? s.outerBoxed : s.outer,
      { [s.invalid]: error },
      {
        [s.inactive]:
          (!input.value || input.value.length === 0) &&
          !labelUp &&
          !['time', 'datetime', 'datetime-local'].includes(type),
      },
      { [s.white]: color === 'white' },
      { [s.disabled]: disabled },
      classNameOuter
    )

    const inputClasses = cn(s.standard, { [s.white]: color === 'white' }, className)

    const labelClasses = cn(s.label)

    return (
      <div className={outerClasses}>
        <label htmlFor={inputId} className={labelClasses}>
          {label}
        </label>
        <input
          id={inputId}
          onChange={this.onChange}
          disabled={disabled}
          type={type}
          autoComplete={type === 'email' || type === 'password' ? 'on' : 'off'}
          {...input}
          {...otherProps}
          className={inputClasses}
        />
        <InputMessage error={error} warning={warning || info} />
        {!hideDot && <InputValid valid={!(error || warning) && !active && input.value} />}
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/Input/Input.jsx